import { SET_IMPORT_ERROR } from '../../../actions/entity';

export default (state = 0, action) => {
  switch (action.type) {
    case SET_IMPORT_ERROR:
      return action.payload.total;
    default:
      return state;
  }
};

export const getTotal = state => state;